import icon from 'vue-svgicon';

icon.register({
    'bold/social-media-facebook-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M19.55 14.56a.5.5 0 0 1-.5.44H17a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h11a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5V9.19a5.69 5.69 0 0 1 5.69-5.69h1.31a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-1.31a1.69 1.69 0 0 0-1.69 1.69v1.31a.5.5 0 0 0 .5.5h2.43a.5.5 0 0 1 .5.56z"/>`,
    },
});
